import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import TemplateManager from './TemplateManager';
import GenerateCertificate from './GenerateCertificate';
import CertificateHistory from './CertificateHistory';

interface CertificatesModuleProps {
  domain: string;
  onBack: () => void;
}

const CertificatesModule: React.FC<CertificatesModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('templates');

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/generate')) setActiveTab('generate');
    else if (path.includes('/history')) setActiveTab('history');
    else setActiveTab('templates');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-award me-2"></i>
            Certificate Management
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>
            Back to Dashboard
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'templates' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/certificates')}
              >
                <i className="bi bi-file-earmark-image me-2"></i>
                Certificate Templates
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'generate' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/certificates/generate')}
              >
                <i className="bi bi-printer me-2"></i>
                Generate Certificates
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'history' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/certificates/history')}
              >
                <i className="bi bi-clock-history me-2"></i>
                Certificate History
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<TemplateManager domain={domain} />} />
          <Route path="generate" element={<GenerateCertificate domain={domain} />} />
          <Route path="history" element={<CertificateHistory domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default CertificatesModule;
